export const TEMPLATE_LIST_DEFAULTS = {
  INITIAL_PAGE: 1,
  INITIAL_LIMIT: 10,
  SEARCH_DELAY_MS: 500,
  TOAST_DURATION: 3000,
};

export const TOAST_MESSAGES = {
  FETCH_ERROR: {
    title: 'Error',
    description: 'Failed to fetch email templates',
  },
  STATS_ERROR: {
    title: 'Warning',
    description: 'Stats API failed. Using fallback data.',
  },
  TYPES_ERROR: {
    title: 'Warning',
    description: 'Using default template types. Some features may be limited.',
  },
  SAVE_SUCCESS: {
    title: 'Success',
    description: 'Template saved successfully',
  },
  SAVE_ERROR: {
    title: 'Error',
    description: 'Failed to save template',
  },
  DELETE_SUCCESS: {
    title: 'Success',
    description: 'Template deleted successfully',
  },
  DELETE_ERROR: {
    title: 'Error',
    description: 'Failed to delete template',
  },
  DUPLICATE_SUCCESS: {
    title: 'Success',
    description: 'Template duplicated successfully',
  },
  DUPLICATE_ERROR: {
    title: 'Error',
    description: 'Failed to duplicate template',
  },
  SET_DEFAULT_SUCCESS: {
    title: 'Success',
    description: 'Template set as default successfully',
  },
  SET_DEFAULT_ERROR: {
    title: 'Error',
    description: 'Failed to set as default',
  },
  TEST_EMAIL_SUCCESS: {
    title: 'Success',
    description: 'Test email sent successfully',
  },
  TEST_EMAIL_ERROR: {
    title: 'Error',
    description: 'Failed to send test email',
  },
};

export const FALLBACK_STATS = {
  total: 0,
  active: 0,
  draft: 0,
  inactive: 0,
  byType: {
    order_confirmation: 0,
    order_ready: 0,
    order_cancelled: 0,
    order_delivered: 0,
    user_registration: 0,
    user_welcome: 0,
    password_reset: 0,
    email_verification: 0,
    loyalty_points_earned: 0,
    loyalty_points_redeemed: 0,
    merchant_registration: 0,
    merchant_approval: 0,
    merchant_rejection: 0,
    promotional: 0,
    newsletter: 0,
    account_suspension: 0,
    account_reactivation: 0,
  },
};
